import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { User } from '@treams/treams-network';
import { Avatar, Chat, Paragraph } from '@treams/treams-ui';

import EvaluationAnswerLine from './EvaluationAnswerLine';

type CardVariant = 'default' | 'empty' | 'irrelevant' | 'goalReflection';

const Unboxed = styled(Box)<{ $side: 'left' | 'right' }>`
	flex-grow: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: ${(props) => (props.$side === 'right' ? 'flex-end' : 'flex-start')};
	text-align: ${(props) => (props.$side === 'right' ? 'right' : 'left')};
`;

export default function EvaluationAnswerWrapper({
	children,
	user,
	side,
	withAvatar = false,
	variant = 'default',
}: {
	children: React.ReactNode;
	side: 'left' | 'right';
	withAvatar?: boolean;
	user: User;
	variant?: CardVariant;
}) {
	if (variant === 'goalReflection') {
		return (
			<>
				<Flex mb={2} alignItems="center">
					<Avatar size={32} user={user} />
					<Paragraph ml={2}>
						{user.firstName} {user.lastName}
					</Paragraph>
				</Flex>

				{children}
			</>
		);
	}

	if (variant === 'empty' || variant === 'irrelevant') {
		return (
			<EvaluationAnswerLine user={user} side={side} withAvatar={withAvatar}>
				<Unboxed $side={side}>{children}</Unboxed>
			</EvaluationAnswerLine>
		);
	}

	return (
		<EvaluationAnswerLine user={user} side={side} withAvatar={withAvatar}>
			<Chat side={side}>{children}</Chat>
		</EvaluationAnswerLine>
	);
}
